import { Box } from "@mui/material";
import React, { type ReactNode } from "react";

import { FormCardItem } from "../FormCardItem";

type Props = {
  headingText?: ReactNode;
  children?: ReactNode;
};

const PaymentBankingInformation = ({ headingText, children }: Props) => {
  return (
    <FormCardItem>
      <Box component="h3" sx={{ color: "primary.main", flexBasis: "100%" }}>
        Mes informations bancaires
      </Box>
      {headingText && <>{headingText}</>}
      {children}
    </FormCardItem>
  );
};

export default PaymentBankingInformation;
